import { Tab } from "@pages/Dashboard/features/Widgets/Tab";
import { useTranslation } from "react-i18next";
import { useSuplyStore } from "@pages/Dashboard/store/suplyChain.state";
import styles from "./styles.module.scss";
import { ExecutiveSummary } from "@components/ExecutiveSummary";
import { useCfoStore } from "src/store/cfo.state";
import CustomSelect from "@components/ui-kit/CustomSelect";
import { useDashboardStore } from "@pages/Dashboard/store/dashboard.state";
import { useAdsAnaliticsStore } from "src/store/ads-analitics.store";
import CashBlocks from "@pages/SupplyChain/components/CashBlock";
import SupplyBlocks from "@pages/SupplyChain/components/SupplyChain";
import { PnlExpandableTable } from "@pages/SupplyChain/components/PnlExpandableTable";
import WaterfallChart from "./net-profit";
import { FEATURE_TOGGLES } from "@lib/featureToggles";
import { useIsOn } from "@hooks/useFeatureToggle";
import { useState } from "react";

export function FinanceBlock() {
  const { t } = useTranslation();
  const [hideFinance, setHideFinance] = useState(false);
  const isRestrictedRoute = location.pathname.includes("finance");
  const { customSuplyWidgets } = useSuplyStore((state) => ({
    customSuplyWidgets: state.customSuplyWidgets,
  }));
  const cfoHeaderEnabled = useIsOn(FEATURE_TOGGLES.CFO_HEADER);
  const cfoExecutiveSummaryEnabled = useIsOn(
    FEATURE_TOGGLES.CFO_EXECUTIVE_SUMMARY,
  );
  const cfoFinancialOverviewEnabled = useIsOn(
    FEATURE_TOGGLES.CFO_FINANCIAL_OVERVIEW_BLOCK,
  );
  const cfoCashFlowEnabled = useIsOn(FEATURE_TOGGLES.CFO_CASH_FLOW_BLOCK);
  const cfoSupplyChainEnabled = useIsOn(FEATURE_TOGGLES.CFO_SUPPLY_CHAIN_BLOCK);
  const cfoWaterfallChartEnabled = useIsOn(FEATURE_TOGGLES.CFO_WATERFALL_CHART);

  const { dateRange, compareType, setCompareType } = useDashboardStore(
    (state) => ({
      dateRange: state.dateRange,
      compareType: state.compareType,
      setCompareType: state.setCompareType,
    }),
  );
  const { compareWith, setCompareWith } = useAdsAnaliticsStore();
  const { isWhatIf } = useCfoStore();

  return (
    <div>
      {cfoHeaderEnabled && (
        <header className="dashboard-widgets__header">
          <h1 className={styles.headerTitle}>{t("CFO")}</h1>
          <div className={styles.containerTab}>
            <div className={styles.customSelectContainer}>
              <Tab
                customSelectedWidgets={customSuplyWidgets}
                isRestrictedRoute={isRestrictedRoute}
                isConfigRoute={true}
              />
              <CustomSelect
                dateRange={dateRange}
                compareWith={compareWith}
                setCompareWith={setCompareWith}
                compareType={compareType}
                setCompareType={setCompareType}
                hideSwitch={true}
              />
            </div>
          </div>
        </header>
      )}
      {isWhatIf && cfoSupplyChainEnabled && (
        <div className={styles.supplyBlock}>
          <h1 className={styles.titleChain}>Supply Chain</h1>
          <SupplyBlocks />
        </div>
      )}
      <div className={styles.executiveBlock}>
        {cfoExecutiveSummaryEnabled && (
          <ExecutiveSummary
            showWhatIf={isWhatIf}
            hideSwitch={true}
            showOnly="CFO"
            brand
          />
        )}

        {/* <div className={styles.perfomanceBlock}>
          <PerformanceCard
            title="Total Sales"
            legendItems={[
              { label: "Organic Social", color: "#5295E0" },
              { label: "Amazon", color: "#FE5858" },
            ]}
            activeView={activeViewSales}
            onByChannelClick={handleByChannelSales}
            onByAsinClick={handleByAsinSales}
          />

          <PerformanceCard
            title="Contribution Profit"
            legendItems={[
              { label: "Organic Social", color: "#5295E0" },
              { label: "Amazon", color: "#FE5858" },
            ]}
            activeView={activeViewContribution}
            onByChannelClick={handleByChannelContribution}
            onByAsinClick={handleByAsinContribution}
          />
        </div> */}

        <div className={styles.chartBetween}>
          {cfoFinancialOverviewEnabled && (
            <div className={styles.tableBlock} hidden={!hideFinance}>
              <h1 className={styles.titleChain}>Financial Overview</h1>
              <PnlExpandableTable />
            </div>
          )}
          {cfoCashFlowEnabled && (
            <div className={styles.financeBlock}>
              <CashBlocks
                setHideFinance={setHideFinance}
                hideFinance={hideFinance}
              />
            </div>
          )}
        </div>
        {cfoWaterfallChartEnabled && (
          <div className={styles.waterfallSection}>
            <WaterfallChart title="Total Net Profit Value" />
          </div>
        )}
        {/* <ExpandableTable
          data={financeData}
          columns={financeColumns}
          withCustomScroll
          rowSelection={rowSelections}
          scroll={{ x: "max-content" }}
          expandable={{
            expandedRowKeys: expandedKeys,
            onExpand: handleExpand,
            rowExpandable: (record) =>
              Array.isArray(record.children) && record.children.length > 0,
          }}
          className={styles.financeTable}
          hideRowSelection={true}
        /> */}
      </div>
    </div>
  );
}
